import React from "react";

 const Pin = ({color ="rgba(0, 39, 99, 0.2)" , style , text , big = false , onClick}) => {

    return big ? <svg onClick={onClick} xmlns="http://www.w3.org/2000/svg"  width="50" height="50"  style={{marginLeft:"-24px",marginTop:"-51px",marginBottom:"41px",...style}}>
    <circle cx="25" cy="25" r="25" fill={color} stroke="none" />
    <circle cx="25" cy="25" r="20" fill="rgba(0, 39, 99, 1)" />
    <text x="25" y="30" font-family="sf_pro" font-weight="bold" font-size="12" text-anchor="middle" fill="white">{text}</text>
</svg> : <svg onClick={onClick} xmlns="http://www.w3.org/2000/svg"  width="44" height="44" style={{marginLeft:"-22px",marginTop:"-44px",marginBottom:"12px",...style}}>
  <circle cx="22" cy="22" r="22" fill={"rgba(0, 39, 99, 0.2)"} />
  <circle cx="22" cy="22" r="18" fill="rgba(0, 39, 99, 1)" />
  <text x="22" y="26" font-family="sf_pro" font-weight="bold" font-size="12" text-anchor="middle" fill="white">{text}</text>
</svg>
 
};

export default Pin



